/* global document CustomEvent */
export const productListEvent = (collection) => {
  try {
    const event = new CustomEvent('productList', {
      detail: {
        collectionTitle: collection.title,
        collectionSlug: collection.slug
      },
      bubbles: true,
      cancelable: true
    });
    document.dispatchEvent(event);
  } catch {
    // Fail silently
  }
};
